
<script> 
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateBlock',
  props:[
    "list"
  ],
  data() {
    return {
      serviceType:[
        {"id":"0","name":"Diğer"},
        {"id":"1","name":"xDsl"},
        {"id":"2","name":"Fiber"},
        {"id":"3","name":"Atm"},
        {"id":"4","name":"Dial-Up"},
        {"id":"5","name":"Metro Ethernet"},
        {"id":"6","name":"ISDN"},
        {"id":"7","name":"Kablo"},
        {"id":"8","name":"Wireless"},
        {"id":"9","name":"Wifi"},
        {"id":"10","name":"Wimax"},
        {"id":"11","name":"Leased-Line"},
        {"id":"12","name":"Uydu"},
        {"id":"13","name":"SMTP Relay"},
        {"id":"14","name":"Frame Relay"},
        {"id":"15","name":"Operatör Networküne Ait"},
        {"id":"16","name":"Devir"},
        {"id":"17","name":"Hiçbir Servise Atanmamış"}
    ],
      form: {},
      submitted: false,
    };
  },
  validations: {
    form: {
      operator: { required },
      service_type: { required },
      start_ip: { required },
      end_ip: { required },
      nat: { required },
      start_date: { required },
      ip_tip: { required },
      location: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  mounted(){
  },
  methods: {
    handleSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;

      } else {
        if(this.form.id)
          this.update();
        else
          this.create();
      }
      this.submitted = false;
    },
    create(){
      this.$http.post('/logs/ipblock/store', this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/logs/ipblock/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/logs/ipblock/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    }
  },
};
</script>

<template>
  <b-modal id="modal-scoped" size="md"  title="İp Blok Ekle / Güncelle"  no-close-on-backdrop hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label>Operatör Adı</label>
               <input
                v-model="form.operator"
                type="text"
                class="form-control"
               
                :class="{
                  'is-invalid': submitted && $v.form.operator.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.operator.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row mb-3">
                <div class="col-md-6">
                    <label> IP Blok Başlangıç</label>
                     <input
                        v-model="form.start_ip"
                        type="text"
                        class="form-control"
                        placeholder="İsim Soyisim"
                        :class="{
                          'is-invalid': submitted && $v.form.start_ip.$error,
                        }"
                      />
                    <div
                        v-if="submitted && !$v.form.start_ip.required"
                        class="invalid-feedback"
                    >
                    Bu alanı doldurmak zorunludur.
                    </div>
                </div> 
                <div class="col-md-6">
                    <label>IP Blok Bitiş</label>
                     <input
                      v-model="form.end_ip"
                      type="text"
                      class="form-control"
                     
                      :class="{
                        'is-invalid': submitted && $v.form.end_ip.$error,
                      }"
                    />
                    <div
                        v-if="submitted && !$v.form.end_ip.required"
                        class="invalid-feedback"
                    >
                    Bu alanı doldurmak zorunludur.
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label>Servis Tipi</label>
                    <v-select
                        label="name" 
                        v-model="form.service_type"
                        :options="serviceType" 
                        :reduce="data => data.id"
                    >
                    <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                    <div
                        v-if="submitted && !$v.form.service_type.required"
                        class="invalid-feedback"
                    >
                    Bu alanı doldurmak zorunludur.
                    </div>
                </div> 
                <div class="col-md-6">
                    <label>Nat Uygulaması Var Mı</label>
                    <select v-model="form.nat" class="form-select">
                        <option value="1">Evet</option>
                        <option value="0">Hayır</option>
                    </select>
                    <div
                        v-if="submitted && !$v.form.nat.required"
                        class="invalid-feedback"
                    >
                    Bu alanı doldurmak zorunludur.
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label>Tahsis Başlangıç Tarihi</label>
                    <input 
                      type="datetime-local" 
                      v-model="form.start_date"   
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.form.start_date.$error,
                      }"
                      >
                    <div
                        v-if="submitted && !$v.form.start_date.required"
                        class="invalid-feedback"
                    >
                    Bu alanı doldurmak zorunludur.
                    </div>
                </div> 
                <div class="col-md-6">
                    <label>Tahsis Bitiş Tarihi</label>
                    <input 
                      type="datetime-local" 
                      v-model="form.end_date"   
                      class="form-control"
                      >
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label>IP Blok Tipi</label>
                    <select v-model="form.ip_tip" class="form-select">
                        <option value="S">Dinamik İp</option>
                        <option value="L">Local İp</option>
                    </select>
                    <div
                        v-if="submitted && !$v.form.ip_tip.required"
                        class="invalid-feedback"
                    >
                    Bu alanı doldurmak zorunludur.
                    </div>
                </div> 
                <div class="col-md-6">
                    <label>Lokasyonu</label>
                     <input
                      v-model="form.location"
                      type="text"
                      class="form-control"
                      placeholder="Lokasyonu"
                      :class="{
                        'is-invalid': submitted && $v.form.location.$error,
                      }"
                    />
                    <div
                        v-if="submitted && !$v.form.location.required"
                        class="invalid-feedback"
                    >
                    Bu alanı doldurmak zorunludur.
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>